import {
  Auth,
  createUserWithEmailAndPassword,
  signInWithPhoneNumber,
  RecaptchaVerifier,
  ConfirmationResult,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
} from '@angular/fire/auth';
import {
  Component,
  AfterViewInit,
  HostListener,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import {
  doc,
  Firestore,
  setDoc,
  updateDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  limit,
} from '@angular/fire/firestore';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageCarouselDialogComponent } from '../profile/image-carousel-dialog/image-carousel-dialog.component';
import { TermsDialogComponent } from 'src/app/components/terms-dialog/terms-dialog.component';
import { VendorsTermsComponent } from 'src/app/components/vendors-terms/vendors-terms.component';
import { GeminiService } from 'src/app/shared/services/gemini.service';

import {
  Storage,
  ref,
  uploadBytes,
  getDownloadURL,
} from '@angular/fire/storage';

@Component({
  selector: 'app-register-business',
  templateUrl: './register-business.component.html',
  styleUrls: ['./register-business.component.scss'],
})
export class RegisterBusinessComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  /* ------------------ YOUR ORIGINAL VARIABLES (UNTOUCHED) ------------------ */
  googleUser: any = null; // Store google user if signed in

  countryList = [
    { name: 'UAE', code: '+971', flag: 'assets/flags/uae.png', limit: 9 },
    { name: 'India', code: '+91', flag: 'assets/flags/india.png', limit: 10 },
    {
      name: 'Saudi Arabia',
      code: '+966',
      flag: 'assets/flags/saudi.png',
      limit: 9,
    },
    { name: 'Kuwait', code: '+965', flag: 'assets/flags/kuwait.png', limit: 8 },
    { name: 'Oman', code: '+968', flag: 'assets/flags/oman.png', limit: 8 },
    { name: 'Qatar', code: '+974', flag: 'assets/flags/qatar.png', limit: 8 },
  ];

  get currentPhoneLimit(): number {
    // Step 1 uses user.countryCode, Step 2 uses user.accountdetails.countryCode
    const code =
      this.step === 1
        ? this.user.countryCode
        : this.user.accountdetails.countryCode;
    const country = this.countryList.find((c) => c.code === code);
    return country ? country.limit : 10;
  }

  get currentTelLimit(): number {
    const country = this.countryList.find(
      (c) => c.code === this.user.accountdetails.telephoneCountryCode,
    );
    return country ? country.limit : 10;
  }

  /* Helper for Template */
  getSelectedCountry() {
    const code =
      this.step === 1
        ? this.user.countryCode
        : this.user.accountdetails.countryCode;
    return this.countryList.find((c) => c.code === code);
  }

  getTelSelectedCountry() {
    return this.countryList.find(
      (c) => c.code === this.user.accountdetails.telephoneCountryCode,
    );
  }

  // Allow only numbers
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  step: number = 1;
  signupMethod: 'email' | 'mobile' = 'mobile';
  isSubmitting = false;
  submitted = false;
  selectedFile: File | null = null;

  user: any = {
    firstname: '',
    emailid: '',
    password: '',
    phoneNumber: '',
    countryCode: '+91',
    mobile: '',
    accountdetails: {
      companyname: '',
      tradeLicenseNo: '',
      issuedBy: '',
      expiryDate: '',
      emailid: '',
      phoneNumber: '',
      telephone: '',
      countryCode: '+971',
      telephoneCountryCode: '+971',
      tradeLicenseCopyUrl: '',
      companyAddress: '',
      companyLogoUrl: '',
      companyLogoBase64: '',
      companyDocuments: [] as any[],
    },
  };

  aiExtractedLicenseNo: string = '';
  isLicenseMismatch: boolean = false;
  licenseMismatchError: string = '';


  otpDigits: string[] = ['', '', '', '', '', ''];
  otp = '';
  confirmationResult: ConfirmationResult | null = null;
  otpSent = false;
  otpVerified = false;

  recaptchaVerifier!: RecaptchaVerifier;
  hidePassword = true;
  hideConfirmPassword = true;
  confirmPassword = '';

  /* ---------------------- NEW AIRBNB CALENDAR VARIABLES ---------------------- */

  showExpiryCalendar = false;
  expiryDate: Date | null = null;
  expiryDisplay: string | null = null;

  currentDate: Date = new Date();
  currentMonth: number = this.currentDate.getMonth();
  currentYear: number = this.currentDate.getFullYear();

  monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  calendarDays: any[] = [];

  get currentMonthName() {
    return this.monthNames[this.currentMonth];
  }

  years: number[] = [];

  generateYears() {
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let i = currentYear - 5; i <= currentYear + 20; i++) {
      this.years.push(i);
    }
  }

  selectMonth(month: number) {
    this.currentMonth = month;
    this.generateCalendar();
  }

  selectYear(year: number) {
    this.currentYear = year;
    this.generateCalendar();
  }

  onExpiryInput(event: any) {
    const value = event.target.value;
    // Format: DD/MM/YYYY
    const parts = value.split('/');
    if (parts.length === 3) {
      const d = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const y = parseInt(parts[2], 10);

      if (!isNaN(d) && !isNaN(m) && !isNaN(y) && y > 1900 && y < 2100) {
        const newDate = new Date(y, m, d);
        if (
          newDate.getDate() === d &&
          newDate.getMonth() === m &&
          newDate.getFullYear() === y
        ) {
          this.expiryDate = newDate;
          this.currentMonth = m;
          this.currentYear = y;
          this.generateCalendar();
        }
      }
    }
  }

  constructor(
    private auth: Auth,
    private afs: Firestore,
    private storage: Storage,
    private router: Router,
    private route: ActivatedRoute,
    private uxservice: UxserviceService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private geminiService: GeminiService,
  ) {}

  termsAccepted = false;

  onTermsCheckboxChange(event: any) {
    if (event.checked) {
      // Force uncheck visually while dialog is open or until accepted
      event.source.checked = this.termsAccepted;
      this.openTermsDialog();
    } else {
      this.termsAccepted = false;
    }
  }

  openTermsDialog(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const dialogRef = this.dialog.open(VendorsTermsComponent, {
      width: '1200px',
      panelClass: 'custom-dialog-container',
      backdropClass: 'blurred-backdrop',
      disableClose: true
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.termsAccepted = true;
      } else {
        this.termsAccepted = false;
      }
    });
  }

  getLogoStyle(): SafeStyle {
    const url = this.user.accountdetails.companyLogoUrl || '/assets/landingpage/Avatar.png';
    return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
  }

  triggerFileInput() {
    document.getElementById('logoInput')?.click();
  }

  async onLogoSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      try {
        this.uxservice.showOverlay('Optimizing & Uploading Logo...');
        
        // 1. Resize/Compress Image
        const optimizedBlob = await this.resizeImage(file, 400, 400);
        const optimizedFile = new File([optimizedBlob], file.name, { type: 'image/jpeg' });
        
        // 2. Convert to Base64
        const base64 = await this.fileToBase64(optimizedFile);

        // 3. Upload to Firebase Storage
        const filePath = `company_logos/${Date.now()}_logo.jpg`;
        const storageRef = ref(this.storage, filePath);
        await uploadBytes(storageRef, optimizedFile);
        const url = await getDownloadURL(storageRef);

        // Update Local State
        this.user.accountdetails.companyLogoUrl = url;
        this.user.accountdetails.companyLogoBase64 = base64;
        this.uxservice.showSuccess('Logo uploaded successfully!');
      } catch (error) {
        console.error('Error uploading logo:', error);
        this.uxservice.showError('Failed to upload logo.');
      } finally {
        this.uxservice.instantCloseOverlay();
      }
    }
  }

  private resizeImage(file: File, maxWidth: number, maxHeight: number): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => {
            if (blob) resolve(blob);
            else reject(new Error('Canvas to Blob failed'));
          }, 'image/jpeg', 0.8);
        };
      };
      reader.onerror = (error) => reject(error);
    });
  }

  private fileToBase64(file: File | Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  ngOnInit(): void {
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        this.prefillUserData();
      }
    });
  }

  async prefillUserData() {
    const fbUser = this.auth.currentUser;
    if (fbUser) {
      try {
        const userRef = doc(this.afs, 'users-list', fbUser.uid);
        const userSnap = await getDoc(userRef);

        let firstname = fbUser.displayName
          ? fbUser.displayName.split(' ')[0]
          : '';
        let emailid = (fbUser.email || '').toLowerCase();
        let phoneData = fbUser.phoneNumber || '';

        if (userSnap.exists()) {
          const data: any = userSnap.data();
          firstname =
            data.firstname || data.displayName?.split(' ')[0] || firstname;
          emailid = data.email || emailid;
          phoneData = data.phoneNumber || data.phone || phoneData;
        }

        this.user.firstname = firstname;
        this.user.emailid = emailid;
        this.user.accountdetails.emailid = emailid;

        // Auto-detect country code from phone string
        if (phoneData) {
          if (phoneData.startsWith('+')) {
            const matchedCountry = this.countryList.find((c) =>
              phoneData.startsWith(c.code),
            );
            if (matchedCountry) {
              this.user.countryCode = matchedCountry.code;
              this.user.mobile = phoneData.replace(matchedCountry.code, '');

              // Also sync step 2 fields
              this.user.accountdetails.countryCode = matchedCountry.code;
              this.user.accountdetails.phoneNumber = this.user.mobile;
            } else {
              this.user.mobile = phoneData;
            }
          } else {
            this.user.mobile = phoneData;
          }
        }
      } catch (e) {
        console.warn('Failed to prefill business registration data', e);
      }
    }
  }

  ngAfterViewInit() {
    this.recaptchaVerifier = new RecaptchaVerifier(
      'biz-recaptcha-container',
      { size: 'invisible' },
      this.auth,
    );
    this.recaptchaVerifier
      .render()
      .catch((e) => console.warn('Recaptcha render error', e));

    this.generateCalendar();
    this.generateYears();
  }

  switchSignupMethod(method: 'email' | 'mobile') {
    this.signupMethod = method;
    this.submitted = false;
  }

  ngOnDestroy() {
    if (this.recaptchaVerifier) {
      this.recaptchaVerifier.clear();
    }
  }

  /* ---------------------- OTP HELPERS ---------------------- */
  trackByIdx(index: number): any {
    return index;
  }

  moveFocus(event: any, index: number) {
    const input = event.target;
    let val = input.value.replace(/[^0-9]/g, '');

    // Handle Paste / Autofill
    if (val.length > 1) {
      for (let i = 0; i < val.length && index + i < 6; i++) {
        this.otpDigits[index + i] = val[i];
      }
      this.otp = this.otpDigits.join('');

      const nextIndex = Math.min(index + val.length, 5);
      setTimeout(() => {
        const nextInput = document.getElementById(`otp-biz-${nextIndex}`);
        nextInput?.focus();
      }, 0);
      return;
    }

    const singleVal = val.slice(-1);
    input.value = singleVal;
    this.otpDigits[index] = singleVal;

    if (singleVal && index < 5) {
      setTimeout(() => {
        const nextInput = document.getElementById(`otp-biz-${index + 1}`);
        nextInput?.focus();
      }, 0);
    }

    this.otp = this.otpDigits.join('');
  }

  handleBackspace(event: any, index: number) {
    if (event.key === 'Backspace') {
      // event.preventDefault(); // Optional: prevent default if needed, but usually better to let it delete first
      if (this.otpDigits[index]) {
        this.otpDigits[index] = '';
        event.target.value = '';
      } else if (index > 0) {
        this.otpDigits[index - 1] = '';
        const prevInput = document.getElementById(
          `otp-biz-${index - 1}`,
        ) as HTMLInputElement;
        if (prevInput) {
          prevInput.value = '';
          prevInput.focus();
        }
      }
      this.otp = this.otpDigits.join('');
    }
  }

  /* ---------------------- CLICK OUTSIDE TO CLOSE ---------------------- */
  @HostListener('document:click')
  closeCalendar() {
    this.showExpiryCalendar = false;
  }

  /* ---------------------- OPEN CALENDAR ---------------------- */
  openExpiryCalendar(event: Event) {
    this.showExpiryCalendar = true;

    this.generateCalendar();

    // Auto-select today's date ONLY if no date is selected
    if (!this.expiryDate) {
      const today = new Date();
      this.expiryDate = today;
      this.expiryDisplay = this.formatDisplayDate(today);
      this.user.accountdetails.expiryDate = this.expiryDisplay;
    }

    event.stopPropagation();
  }

  /* ---------------------- DATE FORMAT ---------------------- */
  formatDisplayDate(date: Date): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

  /* ---------------------- CALENDAR LOGIC (MATCHING SEARCH BAR) ---------------------- */

  // MATCHED FROM SearchBarComponent
  generateCalendar() {
    const days: any[] = [];

    const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
    const lastDate = new Date(
      this.currentYear,
      this.currentMonth + 1,
      0,
    ).getDate();

    const today = new Date();
    const todayDate = today.getDate();
    const todayMonth = today.getMonth();
    const todayYear = today.getFullYear();

    // Empty leading cells
    for (let i = 0; i < firstDay; i++) {
      days.push({
        date: '',
        inactive: true,
        isToday: false,
        isPast: false,
        isSelected: false,
      });
    }

    // Actual days
    for (let d = 1; d <= lastDate; d++) {
      const isToday =
        this.currentYear === todayYear &&
        this.currentMonth === todayMonth &&
        d === todayDate;

      // For expiry, maybe we don't want to gray out past?
      // Keeping logic same as SearchBar for design consistency for now.
      const isPast =
        this.currentYear < todayYear ||
        (this.currentYear === todayYear && this.currentMonth < todayMonth) ||
        (this.currentYear === todayYear &&
          this.currentMonth === todayMonth &&
          d < todayDate);

      const isSelected =
        this.expiryDate &&
        this.expiryDate.getDate() === d &&
        this.expiryDate.getMonth() === this.currentMonth &&
        this.expiryDate.getFullYear() === this.currentYear;

      days.push({
        date: d,
        inactive: false,
        isToday,
        isPast,
        isSelected,
      });
    }

    this.calendarDays = days;
  }

  prevMonth() {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  selectExpiryDay(day: any) {
    if (day.inactive) return; // Allow selecting past dates for now if relevant, or block if strict expiry

    this.expiryDate = new Date(this.currentYear, this.currentMonth, day.date);
    this.expiryDisplay = this.formatDisplayDate(this.expiryDate);

    this.user.accountdetails.expiryDate = this.expiryDisplay;
    this.showExpiryCalendar = false;
  }

  /* ---------------------- NAVIGATION ---------------------- */

  async sendOtp() {
    this.submitted = true;
    if (!this.user.mobile) {
      this.uxservice.showError('Please enter a phone number');
      return;
    }

    try {
      const mobileClean = this.user.mobile.replace(/\D/g, '');
      const phoneNumber = `${this.user.countryCode}${mobileClean}`;

      // Check if phone number is already registered in users-list
      const usersRef = collection(this.afs, 'users-list');
      const q = query(
        usersRef,
        where('phoneNumber', '==', phoneNumber),
        limit(1),
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        this.uxservice.showError(
          'Mobile number is already registered. Please login to enter your password.',
        );
        this.router.navigate(['/login']);
        return;
      }

      this.confirmationResult = await signInWithPhoneNumber(
        this.auth,
        phoneNumber,
        this.recaptchaVerifier,
      );

      this.otpSent = true;
      // this.uxservice.showSuccess('OTP sent to your phone');
    } catch (error: any) {
      this.uxservice.instantCloseOverlay();
      if (error.code === 'auth/too-many-requests') {
        this.uxservice.showError(
          'Too many OTP attempts. Please wait a while or use a different number.',
        );
      } else {
        this.uxservice.showError('Failed to send OTP: ' + error.message);
      }
      this.isSubmitting = false;
    }
  }

  async verifyOtp() {
    if (!this.confirmationResult) return;

    if (this.otp.length !== 6) {
      this.uxservice.showError('Please enter the 6-digit OTP');
      return;
    }

    try {
      const result = await this.confirmationResult.confirm(this.otp);

      this.otpVerified = true;
      this.user.uid = result.user.uid;
      this.uxservice.showSuccess('OTP verified successfully');

      this.goToStep2();
    } catch (error: any) {
      console.error('OTP verification error:', error);
      this.uxservice.showError('Invalid OTP. Try again.');
      this.otpVerified = false;
      this.otpDigits = ['', '', '', '', '', ''];
      this.otp = '';

      setTimeout(() => {
        document.getElementById('otp-biz-0')?.focus();
      }, 100);
    }
  }

  goToStep2() {
    if (this.signupMethod === 'mobile' && !this.otpVerified) {
      this.uxservice.showError('Please verify OTP before continuing');
      return;
    }

    if (!this.user.accountdetails.countryCode && this.user.countryCode) {
      this.user.accountdetails.countryCode = this.user.countryCode;
    }

    if (!this.user.accountdetails.phoneNumber && this.user.mobile) {
      this.user.accountdetails.phoneNumber = this.user.mobile;
    }

    if (!this.user.accountdetails.emailid && this.user.emailid) {
      this.user.accountdetails.emailid = this.user.emailid;
    }

    if (
      !this.user.accountdetails.telephoneCountryCode &&
      this.user.countryCode
    ) {
      this.user.accountdetails.telephoneCountryCode = this.user.countryCode;
    }

    this.step = 2;
  }

  goBack() {
    this.step = 1;
  }

  submitHandler(form: NgForm, e: Event) {
    e.preventDefault();
    this.submitted = true;

    if (form.invalid || !this.termsAccepted) {
      Object.keys(form.controls).forEach((key) => {
        form.controls[key]?.markAsTouched();
      });
      this.uxservice.showError('Please fill all mandatory fields and accept terms');
      return;
    }

    this.isSubmitting = true;
    this.uxservice.showOverlay('Creating Business Account...');

    if (this.user.accountdetails.companyDocuments.length === 0) {
      this.isSubmitting = false;
      this.uxservice.instantCloseOverlay();
      this.uxservice.showError('Please upload your trade license file.');
      return;
    }

    // If Google User exists, skip creating new auth user
    if (this.googleUser) {
      this.saveBusinessData(
        this.googleUser.uid,
        this.googleUser.email || this.user.accountdetails.emailid,
      );
      return;
    }

    if (this.signupMethod === 'email') {
      const email = this.user.emailid.toLowerCase();
      const password = this.user.password;

      createUserWithEmailAndPassword(this.auth, email, password)
        .then(async (credential) => {
          await this.saveBusinessData(credential.user.uid, email);
        })
        .catch((error) => {
          this.isSubmitting = false;
          this.uxservice.instantCloseOverlay();
          if (error.code === 'auth/email-already-in-use') {
            this.uxservice.showError(
              'Email is already registered. Please login to enter your password.',
            );
            this.router.navigate(['/login']);
          } else {
            this.uxservice.showError(error.message);
          }
        });
    } else {
      if (!this.user.uid) {
        this.uxservice.instantCloseOverlay();
        this.uxservice.showError('Please verify phone number first');
        return;
      }

      this.saveBusinessData(
        this.user.uid,
        (this.user.accountdetails.emailid || '').toLowerCase(),
      );
    }
  }

  onTradeLicenseNoChange() {}

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Size Restriction: 10MB
      const MAX_SIZE = 10 * 1024 * 1024; // 10MB
      if (file.size > MAX_SIZE) {
        this.uxservice.showError('File size exceeds the 10MB limit.');
        input.value = ''; // Clear the input
        return;
      }

      const localUrl = URL.createObjectURL(file);

      // Add to local preview immediately
      const newDoc = {
        name: file.name,
        url: localUrl,
        path: '',
        savedAt: new Date().toISOString(),
        uploading: true,
      };
      this.user.accountdetails.companyDocuments.push(newDoc);
      const index = this.user.accountdetails.companyDocuments.length - 1;

      try {
        const filePath = `tradeLicenses/${Date.now()}_${file.name}`;
        const storageRef = ref(this.storage, filePath);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);

        this.user.accountdetails.companyDocuments[index].url = downloadURL;
        this.user.accountdetails.companyDocuments[index].path = filePath;
        this.user.accountdetails.companyDocuments[index].uploading = false;

        // Update primary URL if it's the first one
        if (index === 0) {
          this.user.accountdetails.tradeLicenseCopyUrl = downloadURL;
        }

      } catch (error: any) {
        this.user.accountdetails.companyDocuments.splice(index, 1);
        this.uxservice.showError('File upload failed. Try again.');
      }
    }
  }

  viewDocument(index: number) {
    const doc = this.user.accountdetails.companyDocuments[index];
    if (!doc || !this.isImage(doc.name)) return;

    this.dialog.open(ImageCarouselDialogComponent, {
      data: {
        images: this.user.accountdetails.companyDocuments.filter((d: any) =>
          this.isImage(d.name),
        ),
        initialIndex: this.user.accountdetails.companyDocuments
          .filter((d: any) => this.isImage(d.name))
          .findIndex((d: any) => d.url === doc.url),
      },
      maxWidth: '95vw',
      maxHeight: '95vh',
      panelClass: 'image-viewer-dialog',
    });
  }

  removeDocumentByIndex(index: number) {
    this.user.accountdetails.companyDocuments.splice(index, 1);
    // Sync primary URL if we removed the first one
    if (this.user.accountdetails.companyDocuments.length > 0) {
      this.user.accountdetails.tradeLicenseCopyUrl =
        this.user.accountdetails.companyDocuments[0].url;
    } else {
      this.user.accountdetails.tradeLicenseCopyUrl = '';
      this.selectedFile = null;
      const fileInput = document.getElementById(
        'licenseFile',
      ) as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    }
  }

  removeDocument() {
    this.user.accountdetails.companyDocuments = [];
    this.user.accountdetails.tradeLicenseCopyUrl = '';
    this.selectedFile = null;

    // Clear the file input
    const fileInput = document.getElementById(
      'licenseFile',
    ) as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  // =========================================
  // SAVE BUSINESS DATA → REDIRECT TO PLAN PAGE
  // =========================================
  private async saveBusinessData(uid: string, email: string) {
    try {
      const userRef = doc(this.afs, 'users-list', uid);

      const userData = {
        uid,
        email: email.toLowerCase(),
        phoneNumber: `${this.user.accountdetails.countryCode}${this.user.accountdetails.phoneNumber}`,
        telephone: this.user.accountdetails.telephone
          ? `${this.user.accountdetails.telephoneCountryCode}${this.user.accountdetails.telephone}`
          : '',
        role: 'business',
        firstname: this.user.firstname,
        displayname: this.user.firstname,
        createdAt: new Date().toISOString(),
        companyName: this.user.accountdetails.companyname,
        companyAddress: this.user.accountdetails.companyAddress || '',
        businessLicenseNo: this.user.accountdetails.tradeLicenseNo,
        licenseIssuedBy: this.user.accountdetails.issuedBy,
        licenseValidTill: this.user.accountdetails.expiryDate,
        companyLogoUrl: this.user.accountdetails.companyLogoUrl || '',
        companyLogoBase64: this.user.accountdetails.companyLogoBase64 || '',
        photoURL: this.user.accountdetails.companyLogoUrl || '',
        isIndividual: false,
        accountdetails: {
          companyname: this.user.accountdetails.companyname,
          phoneNumber: `${this.user.accountdetails.countryCode}${this.user.accountdetails.phoneNumber}`,
          tradeLicenseNo: this.user.accountdetails.tradeLicenseNo,
          issuedBy: this.user.accountdetails.issuedBy,
          expiryDate: this.user.accountdetails.expiryDate,
          emailid: (this.user.accountdetails.emailid || '').toLowerCase(),
          telephone: this.user.accountdetails.telephone
            ? `${this.user.accountdetails.telephoneCountryCode}${this.user.accountdetails.telephone}`
            : '',
          traceLicenseCopyUrl:
            this.user.accountdetails.tradeLicenseCopyUrl || '',
          companyAddress: this.user.accountdetails.companyAddress || '',
          companyLogoUrl: this.user.accountdetails.companyLogoUrl || '',
          companyLogoBase64: this.user.accountdetails.companyLogoBase64 || '',
        },
        companyDocuments: this.user.accountdetails.companyDocuments || [],
      };

      await setDoc(userRef, userData, { merge: true });

      this.uxservice.instantCloseOverlay();
      // this.uxservice.showSuccess('Business account created successfully');

      const returnUrl =
        this.route.snapshot.queryParams['returnUrl'] || '/business';
      this.router.navigateByUrl(returnUrl);
    } catch (error: any) {
      console.error('Firestore save error:', error);
      this.uxservice.instantCloseOverlay();
      this.uxservice.showError(error.message);
      this.isSubmitting = false;
    }
  }

  validateEmailSignup() {
    this.submitted = true;
    if (!this.user.password || !this.confirmPassword) {
      this.uxservice.showError('Please fill all password fields');
      return;
    }

    if (this.user.password !== this.confirmPassword) {
      this.uxservice.showError('Passwords do not match');
      return;
    }

    this.goToStep2();
  }

  async googleSignup() {
    this.isSubmitting = true;
    this.uxservice.showOverlay('Connecting to Google...');
    try {
      const provider = new GoogleAuthProvider();
      const credential = await signInWithPopup(this.auth, provider);
      const user = credential.user;

      // Check if user exists
      const userRef = doc(this.afs, 'users-list', user.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        await this.auth.signOut();
        this.uxservice.instantCloseOverlay();

        if (data && data['role'] === 'business') {
          this.uxservice.showError('Account already exists. Please login.');
          const returnUrl =
            this.route.snapshot.queryParams['returnUrl'] || '/business';
          this.router.navigate(['/login'], { queryParams: { returnUrl } });
        } else {
          // Exists but likely as customer
          this.uxservice.showError(
            'Account already exists as a Customer. Please sign in as a user.',
          );
          this.isSubmitting = false;
        }
      } else {
        // New User -> Redirect to Step 2 for Business Details
        this.googleUser = user;

        // Pre-fill details
        this.user.accountdetails.emailid = (user.email || '').toLowerCase();

        // Extract First Name & Capitalize
        let firstName = user.displayName
          ? user.displayName.split(' ')[0]
          : 'User';
        firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
        this.user.firstname = firstName;

        this.user.accountdetails.companyname = user.displayName || '';

        this.uxservice.instantCloseOverlay();
        this.uxservice.showSuccess(
          'Google verified. Please complete business details.',
        );
        this.step = 2; // SKIP TO STEP 2
        this.isSubmitting = false;
      }
    } catch (error: any) {
      this.uxservice.instantCloseOverlay();
      this.uxservice.showError('Google Sign-Up Failed: ' + error.message);
      this.isSubmitting = false;
    }
  }

  isImage(filename: string): boolean {
    if (!filename) return false;
    const ext = filename.split('.').pop()?.toLowerCase();
    return (
      ext === 'jpg' ||
      ext === 'jpeg' ||
      ext === 'png' ||
      ext === 'webp' ||
      ext === 'gif'
    );
  }

  isDoc(filename: string): boolean {
    if (!filename) return false;
    const ext = filename.split('.').pop()?.toLowerCase();
    return ext === 'doc' || ext === 'docx';
  }
}
